module.exports = __webpack_public_path__ + "assets/img/word_course_volume2.3f247b6d.png";